import { DEFAULT } from "api/config/models";
import { IMAGES } from "config/mime";
import MainContext from "context/MainContext";
import { useEffect, useContext } from "react";

function useMediaGallery(props = {}) {
    const context = useContext(MainContext);

    useEffect(() => {
        context.setMediaGalleryClearOnClose(props.clearDataOnClose);
        return () => {
            context.setMediaGalleryClearOnClose(true);
            context.setMediaGalleryOnAttach();
            context.setMediaGalleryWithPermission();
        };
    }, [props.clearDataOnClose]);

    const isMediaGalleryOpen = () => {
        return context.mediaGalleryOpen;
    };

    const openMediaGallery = (prefix, withPermission) => {
        if (!prefix) {
            prefix = DEFAULT;
        }
        if (withPermission) {
            context.setMediaGalleryWithPermission(withPermission);
        }
        context.setMediaGalleryActiveSection(prefix);
        context.setMediaGalleryOpen(true);
    };
    const closeMediaGallery = () => {
        context.setMediaGalleryAccept(IMAGES);
        context.setMediaGalleryActiveSection(DEFAULT);
        context.setMediaGalleryOpen(false);
        if (!context.mediaGalleryClearOnClose) {
            clearMediaGallery();
        }
    };

    // Set params to attach to send via POST request
    const setAttachTo = (params) => {
        // console.log("setAttachTo setMediaGallery", params)
        context.setMediaGalleryAttachParams(params);
    };
    const getAttachTo = () => {
        return context.mediaGalleryAttachParams;
    };

    // Set params to attach to send via POST request
    const setMediaGalleryOnAttach = (callable) => {
        // console.log("setAttachTo setMediaGallery", params)
        context.setMediaGalleryOnAttach(callable);
    };
    const getMediaGalleryOnAttach = () => {
        return context.mediaGalleryOnAttach;
    };

    // Set attached IDs list
    const setAttached = (params, prefix) => {
        if (!prefix) {
            prefix = context.mediaGalleryActiveSection;
        }
        // console.log("setMediaGalleryAttached setMediaGallery", params, prefix)
        let newAttached = params;
        if (prefix) {
            newAttached = {
                ...getMediaGalleryAttached(),
                [prefix]: params,
            };
        }
        context.setMediaGalleryAttached(newAttached);
    };
    const getGalleryFilters = () => {
        return context.mediaGalleryFilters;
    };

    // Set attached IDs list
    const setGalleryFilters = (filters) => {
        context.setMediaGalleryFilters(filters);
    };
    const getMediaGalleryAttached = (prefix) => {
        if (!context.mediaGalleryAttached) return null;

        if (!prefix) {
            prefix = context.mediaGalleryActiveSection;
        }

        return context.mediaGalleryAttached[prefix];
    };

    const clearMediaGallery = () => {
        setAttachTo();
    };

    const setMediaGalleryAccept = (params) => {
        if (!params) {
            params = IMAGES;
        } else if (params === "all") {
            params = "";
        }
        context.setMediaGalleryAccept(params);
    };

    // const setOnAttachChange = (callable) => {
    //     console.log("setOnAttachChange", callable)
    //     context.setAfterAttachChange(callable)
    // }

    // const onAttachChange = async () => {

    //     // const a = await context.afterAttachChange
    //     console.log("setOnAttachChange", context.afterAttachChange)
    //     // context.afterAttachChange()
    //     // afterAttachChange()
    // }

    return {
        mediaGalleryOpen: context.mediaGalleryOpen,
        mediaGalleryAccept: context.mediaGalleryAccept,
        mediaGalleryActiveSection: context.mediaGalleryActiveSection,
        attached: getMediaGalleryAttached(),
        openMediaGallery: (params, withPermission) =>
            openMediaGallery(params, withPermission),
        closeMediaGallery: () => closeMediaGallery(),
        setAttachTo: (params) => setAttachTo(params),
        getAttachTo: () => getAttachTo(),
        isMediaGalleryOpen: () => isMediaGalleryOpen(),
        setAttached: (params, prefix) => setAttached(params, prefix),
        getMediaGalleryAttached: () => getMediaGalleryAttached(),
        setMediaGalleryAccept: (params) => setMediaGalleryAccept(params),
        getGalleryFilters: () => getGalleryFilters(),
        setGalleryFilters: (params) => setGalleryFilters(params),
        setMediaGalleryOnAttach: (callable) =>
            setMediaGalleryOnAttach(callable),
        getMediaGalleryOnAttach: () => getMediaGalleryOnAttach(),
        // setOnAttachChange: (callable) => setOnAttachChange(callable)
    };
}

export default useMediaGallery;
